<template>
   <div class="add-to-cart-table">
      <div class="start-cell">
         <PricingKeyPlan :title="$t('pages.pricing.cart.start.title')"
                         icon="logo_start"
                         :cost="$prices.getProductPrice('BW1Start','perMonth')"
                         productId="BW1Start"
                         :link="{ name: 'pricingStart', params: {productId: 'BW1Start'} }"
                         alternative="logo start">
            {{ $t("pages.pricing.cart.start.desc") }}
            <PlayerProductReadMoreButton :to="{ name: 'pricingStart', params: {productId: 'BW1Start'} }"/>
         </PricingKeyPlan>
      </div>
      <div class="standard-cell">
         <PricingKeyPlan :title="$t('pages.pricing.cart.standard.title')"
                         icon="logo_standard"
                         :cost="$prices.getProductPrice('BW1Standard','perMonth')"
                         productId="BW1Standard"
                         :link="{ name: 'pricingStandard', params: {productId: 'BW1Start'} }"
                         alternative="logo standard">
            {{ $t("pages.pricing.cart.standard.desc") }}
            <PlayerProductReadMoreButton :to="{ name: 'pricingStandard', params: {productId: 'BW1Standard'} }"/>
         </PricingKeyPlan>
      </div>
      <div class="power-cell">
         <PricingKeyPlan :title="$t('pages.pricing.cart.power.title')"
                         icon="logo_power"
                         :cost="$prices.getProductPrice('BW1Power','perMonth')"
                         productId="BW1Power"
                         :link="{ name: 'pricingPower', params: {productId: 'BW1Power'} }"
                         alternative="logo power">
            {{ $t("pages.pricing.cart.power.desc") }}
            <PlayerProductReadMoreButton :to="{ name: 'pricingPower', params: {productId: 'BW1Power'} }"/>
         </PricingKeyPlan>
      </div>
      <div class="volume-cell">
         <h2>
            {{ $t("pages.pricing.cart.volume.title") }}
         </h2>
         <ul>
            <li>{{ $t("pages.pricing.cart.volume.broadcast") }}</li>
            <li>{{ $t("pages.pricing.cart.volume.services") }}</li>
            <li>{{ $t("pages.pricing.cart.volume.supply") }}</li>
            <li>{{ $t("pages.pricing.cart.volume.perpetual") }}</li>
            <li>{{ $t("pages.pricing.cart.volume.outsourcing") }}</li>
         </ul>
         <p>
            {{ $t("pages.pricing.cart.volume.less") }}
         </p>
         <router-link :to="{name:'contact'}" tag="button">
            {{ $t("pages.pricing.cart.volume.contactUs") }}
         </router-link>
      </div>
   </div>

</template>

<script>
    import PricingKeyPlan from "../parts/PricingKeyPlan";
    import PlayerProductReadMoreButton from "../parts/PlayerProductReadMoreButton";
    export default {
        name: "PricingPlansCardViewSection",
        components: {PlayerProductReadMoreButton, PricingKeyPlan}
    }
</script>

<style scoped lang="scss">
   @import "../../../theme/theme";
   //******************************
   //add-to-cart-table
   //******************************
   .add-to-cart-table {
      margin-top: 2em;
      display: grid;
      justify-items: center;
      align-items: normal;
      grid-template: 'start standard power volume';
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-column-gap: 1em;
      grid-row-gap: 1em;
      margin-bottom: 1em;
      color: $text80;
      font-weight: 300;
   }

   @media (min-width: 40em) and (max-width: 60em) {
      .add-to-cart-table {
         grid-template: 'start standard' 'power volume';
         grid-template-columns: 1fr 1fr;
         grid-template-rows: auto auto;
      }
   }

   @media (max-width: 40em) {
      .add-to-cart-table {
         grid-template: 'start' 'standard' 'power' 'volume'
      }
   }

   .add-to-cart-table a img:hover {
      opacity: 0.7;
   }

   .add-to-cart-table a {
      text-decoration: none;
      text-effect: none;
      font-size: 1.2em;
      color: $primary40;
   }

   .add-to-cart-table a:hover {
      color: $primary80;
   }

   .start-cell {
      grid-area: start;
      justify-items: center;
      align-items: center;
      margin-right: auto;
      margin-left: auto;
      border: 1px solid $text20;
   }

   .standard-cell {
      grid-area: standard;
      justify-items: center;
      align-items: center;
      margin-right: auto;
      margin-left: auto;
      border: 1px solid $text20;
   }

   .power-cell {
      grid-area: power;
      justify-items: center;
      align-items: center;
      margin-right: auto;
      margin-left: auto;
      border: 1px solid $text20;
   }

   .volume-cell {
      grid-area: volume;
      display: grid;
      grid-template-rows: auto auto auto 1fr;
      //justify-items: center;
      align-items: center;
      text-align: justify;
      padding-top: 1rem;
      //padding-left: 1rem;
      // padding-right: 1rem;
      border: 1px solid $text20;

      h2 {
         font-size: 1.3rem;
         font-weight: 300;
         padding-left: 1rem;
         padding-right: 1rem;
         color: $primary20;
         margin-bottom: 1em;
      }

      ul {
         padding-left: 1rem;
         padding-right: 1rem;
         font-size: 1rem;
         margin-left: 0.5em;
         margin-top: 0.5em;
         padding-bottom: 0.2em;
         margin-bottom: 0.2em;
         color: $text80;

         li {
            margin-top: 0.2em;
            margin-bottom: 0.2em;
         }
      }

      p {
         padding-left: 1.1rem;
         padding-right: 1rem;
         font-size: 1rem;
         font-weight: 300;
         color: $primary20;
         margin-bottom: 0.5em;
         margin-top: 1em;
      }

      > button {
         padding: 0.7em 2em;
         background: $primary10;
         border: 0;
         text-decoration: none;
         text-effect: none;
         font-size: 1em;
         align-self: end;
         justify-self: normal;
         cursor: pointer;
         color: $primaryText100;
         transition: all .25s;
         outline: none;
      }

      > button:hover {
         background: $primary40;
      }
   }

   .add-to-cart-table .cost {
      font-size: 1.5em;
      color: $text100;
   }

</style>